export class CalfSize {
    public static readonly SMALL = new CalfSize('SMALL', 'Pequeno');
    public static readonly MEDIUM = new CalfSize('MEDIUM', 'Médio');
    public static readonly BIG = new CalfSize('BIG', 'Grande');

    public constructor(
        public readonly name: string,
        public readonly label: string
    ) { }

    public static values(): CalfSize[] {
        return [CalfSize.SMALL, CalfSize.MEDIUM, CalfSize.BIG];
    }

    public static get(name: string): CalfSize {
        const type = CalfSize.values().find((it) => it.name === name);
        if (type == null) {
            throw new Error(`${name} is not a mapped CalfSize.`);
        };
        return type;
    }
}
